import { createContext, useContext, ReactNode } from 'react';
import { AnyRoute } from '@tanstack/router-core';
import { EntityRoutes } from '../types';

export type EntityRouteObject = {
  route: AnyRoute;
  key: string;
};

export type EntityRoutesRecord = Partial<
  Record<EntityRoutes, EntityRouteObject>
>;

export type EntityRoutesMap = Map<EntityRoutes, EntityRouteObject>;

const EntityRoutesMapContext = createContext<EntityRoutesMap>(
  new Map<EntityRoutes, EntityRouteObject>(),
);

interface EntityRoutesMapProviderProps {
  routes: EntityRoutesRecord;
  children: ReactNode;
}

export function EntityRoutesMapProvider({
  routes,
  children,
}: EntityRoutesMapProviderProps) {
  return (
    <EntityRoutesMapContext.Provider
      value={new Map(Object.entries(routes)) as EntityRoutesMap}
    >
      {children}
    </EntityRoutesMapContext.Provider>
  );
}

export function useEntityRoutesMap() {
  const context = useContext(EntityRoutesMapContext);
  if (context === undefined) {
    throw new Error('useRoutes must be used within a RoutesProvider');
  }
  return context;
}
